import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { VariantProps } from 'class-variance-authority';

import { cn } from '@epoch-ui/lib/utils';
import { buttonVariants } from '@epoch-ui/components/Button';

interface LinkButtonProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
  disabled?: boolean;
}

/**
 * LinkButton is a link that looks like a button.
 */

const LinkButton = React.forwardRef<HTMLAnchorElement, LinkButtonProps>(
  ({ className, variant, size, asChild = false, disabled = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'a';
    return (
      <Comp
        data-disabled={disabled}
        aria-disabled={disabled}
        className={cn(
          'tw-text-inherit hover:tw-text-inherit hover:tw-no-underline',
          buttonVariants({ variant, size, className }),
          disabled && 'tw-pointer-events-none tw-cursor-not-allowed tw-opacity-50'
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

export { LinkButton };
